
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Privacy from './pages/Privacy';
import Faq from './pages/Faq';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const { pathname } = window.location;
const Page = pathname === '/privacy' ? Privacy : pathname === '/faq' ? Faq : App;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);
